var error = {
  translation: {
    error: {
      coreNotFound: '获取核心设置失败',
      domainNotAllowed: '您无法使用此域名的邮箱注册',
      emailAlreadyInUse: '邮箱已被使用',
      insufficientPermissions: '权限不足',
      invalidCurrentPassword: '当前密码错误',
      invalidPermissions: '请选择至少一个权限',
      invalidUsernameOrPassword: '用户名或密码无效',
      localRegistrationDisabled: '管理员已禁用本地用户注册',
      noInternetConnection: '无网络连接',
      noOidcProfileFound: '未找到 OIDC 配置文件',
      policyNotAccepted: '请接受服务条款和隐私政策',
      registrationDisabled: '管理员已禁用所有用户注册',
      serverConnectionFailed: '服务器连接失败',
      ssoRegistrationDisabled: '管理员已禁用 SSO 注册',
      tooManyFailedAttempts: '尝试失败次数过多 - 请稍后再试',
      unknownError: '未知错误，请稍后再试',
      usernameAlreadyInUse: '用户名已占用',
      weakPassword: '请使用更强的密码',
    },
  },
};

export { error as default };
